import React from "react";

type notesMessageProps = {
  content:any
  searchedData?: any;
}
// export default function HighlightInner({content,searchedData}:notesMessageProps) {
//   let message_text = content;
//   message_text= message_text?.replace(/(\b(https?|ftp|file):\/\/[\-A-Z0-9+&@#\/%?=~_
//|!:,.;]*[\-A-Z0-9+&@#\/%=~_|])/img,
//     '<a href="$1" target="__blank">$1</a>');
//   message_text = message_text?.replace(/\n/g, "<br />");
//   if(searchedData!=="" && searchedData!== undefined){
//     var term = searchedData;
//     term = term.replace(/(\s+)/,"(<[^>]+>)*$1(<[^>]+>)*");
//     var pattern = new RegExp("("+term+")", "gi");
//     message_text = message_text?.replace(pattern,
//       '<span style="background-color:#FFFF00" tabindex="0" class="tranText">$1</span>'
//     );
//   }
 
//   return (
//     <>
//       <p dangerouslySetInnerHTML={{ __html: message_text.replace(/\n/g, "<br />") }}></p>
//     </>
//   );
// };

export const HighlightSearch = ({content,searchedData}:notesMessageProps) =>{
  const specialChars = /[`!*()_+\-=\[\]{};':"\\|,<>\/?~]/;
  let notallowed =  specialChars.test(searchedData);
  var parts = content;
  if (searchedData && !notallowed) {
    const replaced = searchedData.replace('\\', '');
    const regexp = new RegExp(replaced, 'gi');
    
    const matches = content.match(regexp);
    parts = content.split(new RegExp(`${replaced.replace()}`, 'gi'));
    
    for (var i = 0; i < parts.length; i++) {
      if (i !== parts.length - 1) {
        let match = matches[i];
        while(parts[i + 1] === '') {
          match += matches[++i];
        }
      
        var matchRes = match.slice(-9);
        matchRes = matchRes === "undefined"?match.slice(0,-9):match;
        parts[i] = (
          <React.Fragment key={i}>
            {parts[i]}<span tabIndex={i} style={{background:"#FBF4C5"}} className={
              "tranText" }>
              { matchRes}
            </span>
          </React.Fragment>
        );
      }
     
    }
  }

  
  return (
  <>
    {parts} 
  </>
  );  
};
